/* prettier-ignore */

import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { UserService } from 'src/app/user/services';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LocalStorageService, ToolsService, TranslationService } from 'src/app/services';
import { BreakpointsService } from 'src/app/services/breakpoints.service';
import { MatDialogService } from 'src/app/services/mat-dialog.service';
import { PopUp } from '../../interfaces';
import { PassportQrDialogComponent } from '../passport-qr-dialog/passport-qr-dialog.component';

@Component({
  selector: "app-passport-popup",
  imports: [
    TranslateModule,
  ],
  standalone: true,
  templateUrl: "./popup.component.html",
  styleUrls: ["./popup.component.scss"],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class PassportPopUpComponent {
  public popUp: PopUp = inject(MAT_DIALOG_DATA);

  private _dialogRef = inject(MatDialogRef<PassportPopUpComponent>);
  private _userService = inject(UserService);
  private _localStorageService = inject(LocalStorageService);
  private _breakpointsService = inject(BreakpointsService);
  private _matDialogService = inject(MatDialogService);
  private _toolsService = inject(ToolsService);
  private _translationService = inject(TranslationService);
  protected readonly lang = this._translationService.selectedLanguage;
  private _sanitizer = inject(DomSanitizer);

  protected isMobile = this._breakpointsService.isMobile;

  protected handleCtaClick(): void {
    if (this.isMobile()) {
      this.goToLogin();
      return;
    }

    this._desactivePopUp();
    this._dialogRef.close();
    this._matDialogService.openMatDialog({
      component: PassportQrDialogComponent,
      panelClass: 'passport-qr-dialog',
    });
  }

  goToLogin(){
    this._desactivePopUp();
    this._dialogRef.close();
    this._userService.login();
  }

  closeModal(){
    this._desactivePopUp();
    this._dialogRef.close();
  }

  private _desactivePopUp(): void {
    this._localStorageService.setItem('pop-up-actived', false);
  }

  getSanitizedDescription(): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(this.popUp?.description?.[this.lang()] || '');
  }

  protected openPassportGuide(): void {
    this._toolsService.openPassportGuide();
  }
  
}
